import { render, staticRenderFns } from "./PersonalTasks.vue?vue&type=template&id=7913465a&"
import script from "./PersonalTasks.vue?vue&type=script&lang=js&"
export * from "./PersonalTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports